import { Link } from 'react-router-dom';
import logoIcon from '@/assets/images/logo/logo-icon.png';

/** CUBA SidebarIcon — compact logo when sidebar is collapsed */
export function SidebarIcon() {
  return (
    <div className="logo-icon-wrapper">
      <Link to="/">
        <img className="img-fluid" src={logoIcon} alt="RCATS" />
      </Link>
    </div>
  );
}
